<template>
  <b-row align-h="center">
    <b-col lg="6">
      <h3 class="mb-4">Product Form</h3>
      <b-row>
        <b-col lg="12"
          ><b-form-group
            id="form-group"
            label="Product Owner."
            label-for="form-group__owner"
          >
            <b-form-input
              id="form-group__owner"
              v-model="accounts"
              trim
              disabled
            ></b-form-input> </b-form-group
        ></b-col>
        <b-col lg="8">
          <b-form-group
            id="form-group"
            label="Model Number."
            label-for="form-group__model"
          >
            <b-form-input
              id="form-group__model"
              v-model="model"
              trim
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col lg="4"
          ><b-form-group
            id="form-group"
            label="Part Number."
            label-for="form-group__part"
          >
            <b-form-input
              id="form-group__part"
              v-model="part"
              trim
            ></b-form-input> </b-form-group
        ></b-col>

        <b-col lg="12"
          ><b-form-group
            id="form-group"
            label="Serial Number."
            label-for="form-group__serial"
          >
            <b-form-input
              id="form-group__serial"
              v-model="serial"
              trim
            ></b-form-input> </b-form-group
        ></b-col>

        <b-col lg="12"
          ><b-form-group
            id="form-group"
            label="Product Cost."
            label-for="form-group__cost"
          >
            <b-form-input
              id="form-group__cost"
              v-model="cost"
              trim
            ></b-form-input> </b-form-group
        ></b-col>

        <b-col lg="12" class="mt-4">
          <b-table :items="parts">
            <template v-slot:cell(select_item)="data">
              <b-button
                size="sm"
                @click="select(data.value.id, data.value.index)"
                class="mr-2"
              >
                {{ data.value.isClicked ? 'Remove' : 'Add' }} Item
              </b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" class="mx-auto"
          ><b-button
            variant="primary"
            @click="submit"
            :disabled="
              parts.length == 0 || selected.length == 0 || isProcessing
            "
            >Submit Form</b-button
          ></b-col
        >
      </b-row>
    </b-col>
    <Decode
      :isVisible="isVisible"
      @clicked="child_passphrase"
      @redirect="child_redirect"
    />
  </b-row>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { signAndSendTransaction } from '@/ethereum/send'
import Decode from '@/components/modal/Decode.vue'
import CryptoJS from 'crypto-js'
import web3 from 'web3'
export default {
  components: {
    Decode
  },
  methods: {
    ...mapActions(['init_notification']),
    submit: async function() {
      const {
        model,
        part,
        serial,
        cost,
        contracts,
        selected,
        passphrase
      } = this

      if (!passphrase) {
        this.isVisible = true
        return
      }

      this.isProcessing = !this.isProcessing

      let result = await contracts.Implementation.methods.createProduct(
        model,
        part,
        serial,
        cost,
        selected
      )

      let decrypted = CryptoJS.AES.decrypt(
        sessionStorage.getItem('private_key'),
        this.passphrase
      )

      const acc = decrypted.toString(CryptoJS.enc.Utf8)
      const response = await signAndSendTransaction(result, acc)

      if (response) {
        this.isProcessing = !this.isProcessing
        this.init_notification({
          isVisible: true,
          header: 'Product registered with transaction hash of',
          body: ` ${response.transactionHash}`
        })
      }
    },
    child_passphrase: function(value) {
      try {
        let decrypted = CryptoJS.AES.decrypt(
          sessionStorage.getItem('private_key'),
          value
        )

        if (
          decrypted.toString(CryptoJS.enc.Utf8) === '' ||
          decrypted.toString(CryptoJS.enc.Utf8).length === 0
        )
          return alert('Invalid passphrase')

        this.passphrase = value
        this.isVisible = false
      } catch (error) {
        const { message } = error

        if (message === 'ciphertext is null')
          return console.log('Encrypted value is null')
      }
    },
    child_redirect: function(path) {
      this.$router.push(path)
    },
    select: function(id) {
      this.selected.push(Number(id))
      // if (this.selected.includes(Number(id))) {
      //   this.selected = this.selected.filter(n => Number(n) !== Number(id))
      // } else {
      //   this.selected = this.selected.push(Number(id))
      // }
    }
  },
  computed: {
    ...mapState(['contracts'])
  },
  async mounted() {
    const { contracts, accounts } = this

    let result = await contracts.Implementation.methods
      .getParticipantParts(accounts)
      .call({ from: accounts })

    if (!result) return

    for (var i = 0; i < result.length; i++) {
      let item = await contracts.Implementation.methods
        .getPartDetails(result[i])
        .call({ from: accounts })

      if (!item[5] && web3.utils.toChecksumAddress(accounts) === item[6]) {
        this.parts.push({
          partNumber: item[0],
          serialNumber: item[1],
          cost: item[2],
          mfgTimeStamp: item[3],
          select_item: {
            isClicked: false,
            id: result[i],
            index: i
          }
        })
      }
    }

    console.log('Parts : ', this.parts)
  },
  data() {
    return {
      model: '',
      part: '',
      serial: '',
      cost: '',
      parts: [],
      selected: [],
      isProcessing: false,
      isVisible: false,
      passphrase: '',
      accounts: sessionStorage.getItem('address')
    }
  }
}
</script>

<style scoped>
.col-lg-6 {
  padding: 20px 50px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 7px 23px #88888852;
  border-radius: 12px;
}

.form-group {
  margin-bottom: 1rem;
}
</style>
